import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=b95b71be&scoped=true&lang=scss"

import exportComponent from "/devcloud/slavespace/slave1-new/workspace/j_0fNImIEQ/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b95b71be"]])

export default __exports__